import { Chip } from '@mui/material';
import styled from 'styled-components';

import { colors, layout } from 'config/theme';

export const Content = styled.div<{ open: boolean }>`
  max-height: ${(props) => (props.open ? '100%' : '0')};
  overflow: hidden;
  transition: all 0.3s ease-out;
`;

export const Heading = styled.div<{ saved: boolean; open: boolean }>`
  border: 1px solid #ddd;
  margin-right: 50px;
  background: ${(props) => (props.saved ? colors.success.light : '#F0F0F0')};
  color: ${colors.black};
  padding: 10px 12px 10px 20px;
  font-weight: bold;
  margin-bottom: 0;
  display: flex;
  width: 100%;
  flex-flow: row;
  border-radius: ${(props) =>
    props.open
      ? `${layout.borderRadius.m} ${layout.borderRadius.m} 0 0`
      : `${layout.borderRadius.m}`};
  justify-content: space-between;
  align-items: center;
`;

export const HeadingWrapper = styled.div`
  margin-right: -50px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 400;
  display: flex;
  flex-flow: row;
`;

export const DetailsWrapper = styled.div`
  outline: 1px;
  outline-color: ${colors.gray};
  margin-bottom: 10px;
`;

export const StyledChip = styled(Chip)`
  margin-left: 10px;
`;

export const ButtonWrapper = styled.span`
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
`;

export const TagWrapper = styled.div`
  margin-right: 18px;
  margin-left: auto;
`;
